import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'spa-apps-software-reports-cycle-time-report.precondition.not-available-page.title',
		defaultMessage: 'Limited project permissions',
		description: 'Limited permission page title',
	},
	description: {
		id: 'spa-apps-software-reports-cycle-time-report.precondition.not-available-page.description',
		defaultMessage: 'You do not have permission to view this report. Contact admin for details.',
		description: 'The description to describe why the user is seeing this page.',
	},
	goBackToProject: {
		id: 'spa-apps-software-reports-cycle-time-report.precondition.not-available-page.go-back-to-project',
		defaultMessage: 'Go back to project',
		description: 'The button label to lead the user to go back to project',
	},
});
